// extracted by mini-css-extract-plugin
module.exports = {"invalidElementsList":"src-containers-Form-Common-SubformNotification-styles___invalidElementsList"};